$('body').ready(function() {
  const inputsCategory = $('.js-filterBase').find('input:not(.js-filterProduct)')
  const filterTabDisable = $('.js-filter-tab_disable')


  if (!inputsCategory.is(':checked')) {
    filterTabDisable.addClass('disabled');
  } else {
    filterTabDisable.find('svg').removeClass('select-disabled')
  }
})

$(document).on('change', '.js-filterBaseAll', function() {
  const $this = $(this);
  const parent = $this.parents('.filter-tab');

  if ($this.prop('checked') === true) {
    parent.find('input:not(.js-filterBaseAll):not(.js-filterProduct)').prop('checked', false);
  }
});

$(document).on('change', '.js-filterBase input:not(.js-filterBaseAll)', function() {
  const $this = $(this);
  const parent = $this.parents('.js-filterBase');
  const filterBaseAll = parent.find('.js-filterBaseAll');

  if ($this.prop('checked') && filterBaseAll !== undefined
    && !$this.hasClass('js-filterProduct')
    && !$this.hasClass('js-filterCategory')) {
    filterBaseAll.prop('checked', false);
  }
});

$(document).on('change', '.js-filterBase input', function() {
  const $this = $(this);
  const parent = $this.parents('.js-filterBase');
  const filterTabDisable = parent.find('.js-filter-tab_disable');
  const productInput = parent.find('input:not(.js-filterProduct)')

  if (parent.find('.js-filter-tab_disable').length > 0) {
    if ($this.prop('checked')) {
      filterTabDisable.removeClass('disabled');
      $('.filter-tab__prompt').addClass('filter-tab__prompt_hidden')
      filterTabDisable.find('svg').removeClass('select-disabled')

    } else if (!productInput.is(':checked')) {
      filterTabDisable.addClass('disabled');
      filterTabDisable.parent().removeClass('filter-tab_active')
      productInput.prop('checked', false);
      $('.filter-tab__prompt').removeClass('filter-tab__prompt_hidden')
      filterTabDisable.find('svg').addClass('select-disabled')
    }
  }
})

$(document).on('change', '.js-filterBase input:not(.js-filterProduct)', function () {
  const $this = $(this);
  const filterBaseData = $('.js-filterBase').data('url');
  const parent = $this.parents('.js-filterBase');
  const productInput = parent.find('input');
  const filterTabDisable = parent.find('.js-filter-tab_disable');
  const checkedInput = productInput.filter(':checked');

  if (checkedInput) {
    const result = {};
    checkedInput.each(function (index, item) {
      if (!result.hasOwnProperty(item.name)) {
        result[item.name] = [];
      }
      result[item.name].push(item.value);
    });
    $.ajax({
      type: "GET",
      dataType: 'HTML',
      url: filterBaseData,
      data: result,
      success: function success(data) {
        $('.js-filter-input-ul').remove();
        filterTabDisable.last().after(data);
      }
    });
  }
});
